import { Log } from 'modules/core/components/ActivityLog/Log'
import { Source } from 'modules/core/components/ActivityLog/Log/types'
import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

interface Props {
  identifier: string
  parentResourceId?: number
  updatesTitle: string
  filteredSources?: Source
  upgradeElement?: React.ReactNode
  loading?: boolean
  onClose?: () => void
}

export const ActivityLogSidepanel = ({
  identifier,
  parentResourceId,
  updatesTitle,
  filteredSources,
  loading,
  upgradeElement,
  onClose,
}: Props) => {
  const closeSidepanel = () => {
    onClose && onClose()
  }

  return (
    <Sidepanel
      width="wide"
      boxPadding={false}
      title={i18n.t('activity_log.title')}
      open
      onClose={closeSidepanel}
    >
      <Log
        identifier={identifier}
        parentResourceId={parentResourceId}
        updatesTitle={updatesTitle}
        filteredSources={filteredSources}
        upgradeElement={upgradeElement}
        loading={loading}
        fromSidepanel
      />
    </Sidepanel>
  )
}
